import React from 'react';
import { User } from '../../types/auth.types';
import { SidebarLogo } from './sidebar/SidebarLogo';
import { ProjectInfo } from './sidebar/ProjectInfo';
import { NavSection } from './sidebar/NavSection';
import { SidebarFooter } from './sidebar/SidebarFooter';
import { useSidebarSections } from './sidebar/useSidebarSections';

interface SidebarProps {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
    expandedNavSections: Set<string>;
    toggleNavSection: (section: string) => void;
    navItems: any[];
    activeProject?: string;
    activeStandard?: string;
    isDarkMode: boolean;
    toggleTheme: () => void;
    logout: () => void;
    user: User | null;
}

export const Sidebar: React.FC<SidebarProps> = ({
    sidebarOpen,
    setSidebarOpen,
    expandedNavSections,
    toggleNavSection,
    navItems,
    isDarkMode,
    toggleTheme,
    logout,
    user,
    activeProject,
    activeStandard
}) => {
    const sections = useSidebarSections(navItems);

    return (
        <aside className={`
            fixed inset-y-0 left-0 z-50 
            ${sidebarOpen ? 'w-64' : 'w-16'} 
            bg-[var(--bg-secondary)] border-r border-[var(--border-color)]
            transition-all duration-300 flex flex-col overflow-y-auto
        `}>
            <SidebarLogo
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />

            <div className="gradient-header-process"></div>

            <ProjectInfo
                sidebarOpen={sidebarOpen}
                activeProject={activeProject}
                activeStandard={activeStandard}
            />

            <nav className="flex-1 p-3">
                <ul className="space-y-0.5">
                    {sections.map((sec, secIndex) => (
                        <NavSection
                            key={`section-${secIndex}`}
                            {...sec}
                            sidebarOpen={sidebarOpen}
                            isExpanded={expandedNavSections.has(sec.section)}
                            toggleNavSection={toggleNavSection}
                        />
                    ))}
                </ul>
            </nav>

            <SidebarFooter
                sidebarOpen={sidebarOpen}
                isDarkMode={isDarkMode}
                toggleTheme={toggleTheme}
                logout={logout}
                user={user}
            />
        </aside>
    );
};
